import { useEffect, useState } from "react";
import {
  cancelUserReservation,
  CurrentReservationType,
  ReservationTournamentResponse,
} from "../../../../../../api/reservation";
import { TimerControllerPopupInputWrapper } from "../../../../style";
import { useParticipantContext } from "../../hooks/participant-context";
import {
  ControllerReservationListBody,
  ControllerReservationListHeader,
  ControllerReservationListItem,
  ControllerReservationListWrapper,
  ControllerSitInReservationWrapper,
} from "./style";
import { formatDateWithDote } from "../../../../../../utils/date";
import { PaginationWrapper } from "../../../../../../component/CommonTable";
import PopupPagination from "../../../../../../component/Pagination/popupPagination";
import { useRecoilValue } from "recoil";
import { WideState } from "../../../../../../recoil/wide";

const ControllerSitInReservationPopup = () => {
  const {
    reservationList,
    reloadData,
    setIsReservationPopup,
    handleReservationParticipation,
  } = useParticipantContext();
  const limit = 5;
  const [search, setSearch] = useState<string>("");
  const [list, setList] = useState<ReservationTournamentResponse[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const isWide = useRecoilValue(WideState);

  useEffect(() => {
    setCurrentPage(1);
  }, [search]);

  useEffect(() => {
    if (search) {
      const searchLower = search.toLowerCase();
      const filterList = reservationList.filter(
        (item) =>
          item.nickname.toLowerCase().includes(searchLower) ||
          (item.phoneNumber && item.phoneNumber.includes(search)),
      );
      setList(filterList.slice((currentPage - 1) * limit, currentPage * limit));
      setTotalPage(Math.max(1, Math.ceil(filterList.length / limit)));
      return;
    }
    setList(
      reservationList.slice((currentPage - 1) * limit, currentPage * limit),
    );
    setTotalPage(Math.max(1, Math.ceil(reservationList.length / limit)));
  }, [reservationList, currentPage, search]);

  // 회원 예약 취소
  const cancelReservation = async (item: ReservationTournamentResponse) => {
    const confirm = window.confirm(
      `${item.nickname}님의 예약을 삭제하시겠습니까?`,
    );
    if (!confirm) return;
    try {
      await cancelUserReservation(item.id);
      reloadData();
      setCurrentPage(1);
    } catch (e: any) {
      if (e.status === 403) {
        alert(e.response.data.message);
        return;
      }
      alert(e.massage);
    }
  };

  const getReservationTypeText = (
    reservation: ReservationTournamentResponse,
  ) => {
    if (reservation?.type === CurrentReservationType.SEED) return "(래빗)";
    if (reservation?.type === CurrentReservationType.POINT) return "(이용권)";
    return "";
  };

  return (
    <ControllerSitInReservationWrapper isWide={isWide}>
      <div className="title">
        예약자 목록
        <img
          src="/image-web/solution/close.svg"
          alt="close"
          onClick={() => setIsReservationPopup(false)}
        />
      </div>
      <TimerControllerPopupInputWrapper height={isWide ? "45px" : "33px"}>
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="닉네임을 검색하세요. "
        />
      </TimerControllerPopupInputWrapper>
      <ControllerReservationListWrapper isWide={isWide}>
        <ControllerReservationListHeader isWide={isWide}>
          <div className="date">예약일자</div>
          <div className="name">닉네임</div>
          <div className="phone">{isWide ? "전화번호 뒷자리" : "뒷자리"}</div>
          <div className="button"></div>
          <div className="button"></div>
        </ControllerReservationListHeader>
        <ControllerReservationListBody>
          {list.map((item, index) => (
            <ControllerReservationListItem key={index} isWide={isWide}>
              <div className="date">{formatDateWithDote(item.createdAt)}</div>
              <div className="name">
                {item.nickname} {isWide ? getReservationTypeText(item) : ""}
              </div>
              <div className="phone">{item.phoneNumber}</div>
              {!item.isSitin && (
                <>
                  <div
                    className="button"
                    onClick={() => handleReservationParticipation(item)}
                  >
                    싯인
                  </div>
                  <div
                    className="button"
                    onClick={() => cancelReservation(item)}
                  >
                    삭제
                  </div>
                </>
              )}
            </ControllerReservationListItem>
          ))}
        </ControllerReservationListBody>
      </ControllerReservationListWrapper>
      {totalPage > 1 && (
        <PaginationWrapper>
          <PopupPagination
            currentPage={currentPage}
            totalPages={totalPage}
            onPageChange={setCurrentPage}
          />
        </PaginationWrapper>
      )}
    </ControllerSitInReservationWrapper>
  );
};

export default ControllerSitInReservationPopup;
